import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import QuoteFormUpdated from './components/QuoteFormUpdated';
import ManufacturerSelect from './components/ManufacturerSelect';
import BrandPage from './components/BrandPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/quote" element={<QuoteFormUpdated />} />
        <Route path="/manufacturers" element={<ManufacturerSelect />} />
        <Route path="/brand/:brand" element={<BrandPage />} />
        <Route path="/" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
